import type { OpenPortalParams } from './utils/types'

import { appendScript } from '@/helpers/common'

const {
  VITE_CHARGEBEE_SITE,
  VITE_CHARGEBEE_DOMAIN,
} = import.meta.env

let chargebeeInstance: ReturnType<typeof Chargebee['getInstance']> | null = null

export const useChargebee = () => {

  const SCRIPT_ID = 'chargebee-script'

  const init = async () => {
    await appendScript(
      'https://js.chargebee.com/v2/chargebee.js',
      SCRIPT_ID,
    )
    if (chargebeeInstance) return
    chargebeeInstance = Chargebee.init({
      site: VITE_CHARGEBEE_SITE,
      domain: VITE_CHARGEBEE_DOMAIN,
    })
  }

  const openCheckout = (hostedPage: () => Promise<any>, success: (hostedPageId: string) => void) => {
    chargebeeInstance?.openCheckout({
      hostedPage,
      success,
    })
  }

  const setPortalSession = async (portalSession: () => Promise<any>) => {
    await chargebeeInstance?.setPortalSession(portalSession)
  }

  const openPortal = async (
    params?: OpenPortalParams,
    sectionType: 'edit_subscription' | 'portal_payment_methods' | 'portal_billing_history' | undefined = 'edit_subscription',
  ) => {
    chargebeeInstance?.createChargebeePortal().open({
      loaded: params?.loadedCallback,
      close: params?.closeCallback,
      paymentSourceAdd: params?.paymentSourceAddCallback,
      paymentSourceUpdate: params?.paymentSourceUpdateCallback
    }, {
      sectionType,
      params: {
        subscriptionId: 'active_direct'
      }
    })
  }

  const destroy = async () => {
    chargebeeInstance?.logout()
    chargebeeInstance?.closeAll()
    chargebeeInstance = null
  }

  return {
    init,
    openCheckout,
    setPortalSession,
    openPortal,
    destroy
  }
}
